import React, { createContext, useContext, useState, useCallback } from "react";

const translations = {
  es: {
    nav_home: "Inicio",
    nav_shop: "Tienda",
    nav_about: "Nosotras",
    nav_contact: "Contacto",
    hero_overline: "Joyería artesanal · Colombia",
    hero_title: "Piezas que cuentan tu historia",
    hero_sub: "Joyas hechas a mano con alma, inspiradas en la flor de la pasión.",
    hero_cta: "Ver colección",
    hero_cta2: "Nuestra historia",
    featured_overline: "Selección especial",
    featured_title: "Piezas destacadas",
    featured_sub: "Nuestras creaciones más queridas, hechas a mano una a una.",
    view_all: "Ver toda la tienda",
    about_overline: "Nuestro oficio",
    about_title: "Hecho a mano, con pasión",
    about_p1: "En Pasionaria cada joya nace de las manos de artesanas colombianas. Trabajamos con materiales nobles y técnicas tradicionales para crear piezas únicas.",
    about_p2: "Creemos en la belleza de lo imperfecto, en lo lento y en lo auténtico. Cada pieza lleva el tiempo y el cariño de quien la creó.",
    shop_title: "Nuestra tienda",
    shop_sub: "Explora todas nuestras creaciones artesanales.",
    filter_all: "Todo",
    cat_collares: "Collares",
    cat_aretes: "Aretes",
    cat_pulseras: "Pulseras",
    cat_anillos: "Anillos",
    add_to_cart: "Agregar al carrito",
    materials: "Materiales",
    out_of_stock: "Agotado",
    back_to_shop: "Volver a la tienda",
    cart_title: "Tu carrito",
    cart_empty: "Tu carrito está vacío",
    cart_empty_cta: "Explorar tienda",
    cart_total: "Total",
    cart_qty: "Cantidad",
    remove: "Quitar",
    checkout_title: "Finalizar pedido",
    pay_bold: "Pagar con Bold",
    order_whatsapp: "Pedir por WhatsApp",
    checkout_note: "Elige cómo quieres completar tu pedido. Por WhatsApp coordinamos envío y detalles.",
    contact_title: "Hablemos",
    contact_sub: "Escríbenos por WhatsApp o síguenos en Instagram.",
    footer_tagline: "Joyería artesanal hecha con pasión.",
    footer_rights: "Todos los derechos reservados.",
    instagram_title: "Síguenos en Instagram",
    instagram_sub: "@pasionaria30",
    admin: "Admin",
    price_from: "Desde",
    marquee: "Hecho a mano",
    mani_overline: "Nuestra filosofía",
    mani_title: "Tres verdades que sostienen cada pieza",
    ch1_title: "Hecho a mano",
    ch1_text: "Ninguna máquina reemplaza el pulso de una artesana. Cada joya se moldea, se teje y se pule a mano, una a una.",
    ch2_title: "Materiales con alma",
    ch2_text: "Trabajamos con metales nobles, piedras naturales e hilos encerados elegidos por su carácter y durabilidad.",
    ch3_title: "Piezas únicas",
    ch3_text: "Producimos en pequeñas cantidades. Lo que llevas puesto es tan singular como la historia que quieres contar.",
    spotlight_overline: "La pieza",
    spotlight_title: "El detalle lo es todo",
    spotlight_text: "Miramos de cerca cada engaste, cada curva y cada acabado. Porque la diferencia entre una joya y una joya inolvidable vive en los detalles.",
    news_overline: "Únete al club",
    news_title: "10% de descuento de bienvenida",
    news_sub: "Suscríbete y recibe un cupón para tu primera compra, además de novedades y lanzamientos.",
    news_placeholder: "Tu correo electrónico",
    news_btn: "Quiero mi cupón",
    news_success: "¡Listo! Usa este cupón en tu pedido:",
    news_copy: "Copiar",
    news_copied: "¡Copiado!",
    news_error: "Ingresa un correo válido",
    news_already: "Ya estabas suscrito. Tu cupón es:",
  },
  en: {
    nav_home: "Home",
    nav_shop: "Shop",
    nav_about: "About",
    nav_contact: "Contact",
    hero_overline: "Handcrafted jewelry · Colombia",
    hero_title: "Pieces that tell your story",
    hero_sub: "Handmade jewelry with soul, inspired by the passion flower.",
    hero_cta: "Shop collection",
    hero_cta2: "Our story",
    featured_overline: "Curated selection",
    featured_title: "Featured pieces",
    featured_sub: "Our most-loved creations, handmade one by one.",
    view_all: "View full shop",
    about_overline: "Our craft",
    about_title: "Handmade, with passion",
    about_p1: "At Pasionaria every piece is born from the hands of Colombian artisans. We work with noble materials and traditional techniques to create unique pieces.",
    about_p2: "We believe in the beauty of the imperfect, the slow and the authentic. Every piece carries the time and care of its maker.",
    shop_title: "Our shop",
    shop_sub: "Explore all our handcrafted creations.",
    filter_all: "All",
    cat_collares: "Necklaces",
    cat_aretes: "Earrings",
    cat_pulseras: "Bracelets",
    cat_anillos: "Rings",
    add_to_cart: "Add to cart",
    materials: "Materials",
    out_of_stock: "Sold out",
    back_to_shop: "Back to shop",
    cart_title: "Your cart",
    cart_empty: "Your cart is empty",
    cart_empty_cta: "Browse shop",
    cart_total: "Total",
    cart_qty: "Quantity",
    remove: "Remove",
    checkout_title: "Complete your order",
    pay_bold: "Pay with Bold",
    order_whatsapp: "Order via WhatsApp",
    checkout_note: "Choose how to complete your order. Via WhatsApp we arrange shipping and details.",
    contact_title: "Let's talk",
    contact_sub: "Write to us on WhatsApp or follow us on Instagram.",
    footer_tagline: "Handcrafted jewelry made with passion.",
    footer_rights: "All rights reserved.",
    instagram_title: "Follow us on Instagram",
    instagram_sub: "@pasionaria30",
    admin: "Admin",
    price_from: "From",
    marquee: "Handcrafted",
    mani_overline: "Our philosophy",
    mani_title: "Three truths behind every piece",
    ch1_title: "Made by hand",
    ch1_text: "No machine replaces the pulse of an artisan. Every piece is shaped, woven and polished by hand, one at a time.",
    ch2_title: "Materials with soul",
    ch2_text: "We work with noble metals, natural stones and waxed threads chosen for their character and durability.",
    ch3_title: "One of a kind",
    ch3_text: "We craft in small batches. What you wear is as singular as the story you want to tell.",
    spotlight_overline: "The piece",
    spotlight_title: "The detail is everything",
    spotlight_text: "We look closely at every setting, every curve and every finish. Because the difference between a piece and an unforgettable one lives in the details.",
    news_overline: "Join the club",
    news_title: "10% welcome discount",
    news_sub: "Subscribe and get a coupon for your first purchase, plus news and new releases.",
    news_placeholder: "Your email address",
    news_btn: "Get my coupon",
    news_success: "Done! Use this coupon on your order:",
    news_copy: "Copy",
    news_copied: "Copied!",
    news_error: "Enter a valid email",
    news_already: "You were already subscribed. Your coupon is:",
  },
};

const LangContext = createContext();

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("pas_lang") || "es");
  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "es" ? "en" : "es";
      localStorage.setItem("pas_lang", next);
      return next;
    });
  }, []);
  const t = useCallback((key) => translations[lang][key] || key, [lang]);
  return (
    <LangContext.Provider value={{ lang, toggle, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
